var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1644 5.2526C21.5772 5.61952 21.6143 6.25159 21.2474 6.66437L10.5808 18.6644C10.391 18.8779 10.119 19 9.83334 19C9.54771 19 9.2757 18.8779 9.08593 18.6644L3.7526 12.6644C3.38568 12.2516 3.42286 11.6195 3.83565 11.2526C4.24843 10.8857 4.8805 10.9229 5.24742 11.3356L9.83334 16.4948L19.7526 5.33565C20.1195 4.92286 20.7516 4.88568 21.1644 5.2526Z",
    fill: "#FFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon_check.d796270dab803fb2ac8aad9bdde42fbe.svg";
export { ForwardRef as ReactComponent };